import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa";

const ApiServices = () => {
    const navigate = useNavigate();
    const [plans, setPlans] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchPlans = async () => {
            try {
                const response = await fetch("/APIServicesPlan.json");
                if (!response.ok) {
                    throw new Error("Failed to fetch plans");
                }
                const jsonData = await response.json();
                setPlans(jsonData);
            } catch (error) {
                console.error("Error fetching data:", error);
                setError(error.message);
            } finally {
                setIsLoading(false);
            }
        };

        fetchPlans();
    }, []);

    if (isLoading) {
        return (
            <div className="flex justify-center items-center min-h-screen bg-slate-50">
                <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-emerald-500"></div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="flex justify-center items-center min-h-screen bg-slate-50">
                <div className="bg-white p-8 rounded-3xl shadow-xl text-center max-w-md border border-slate-200">
                    <h2 className="text-2xl font-bold text-rose-500 mb-4">Error Loading Plans</h2>
                    <p className="text-slate-600 mb-6">{error}</p>
                    <button
                        onClick={() => window.location.reload()}
                        className="bg-emerald-600 hover:bg-emerald-700 text-white font-bold py-3 px-8 rounded-xl transition duration-300 shadow-md shadow-emerald-600/20"
                    >
                        Retry
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div className="bg-slate-50 text-slate-800 antialiased selection:bg-emerald-500 selection:text-white">
            <style>{`
                @keyframes ticker {
                    0% { transform: translateX(0); }
                    100% { transform: translateX(-50%); }
                }
                .animate-ticker {
                    display: flex;
                    width: max-content;
                    animation: ticker 25s linear infinite;
                }
                .animate-ticker:hover {
                    animation-play-state: paused;
                }
                @keyframes float {
                    0%, 100% { transform: translateY(0px) rotate(0deg); }
                    50% { transform: translateY(-8px) rotate(1deg); }
                }
                .animate-float {
                    animation: float 6s ease-in-out infinite;
                }
                .perspective-1000 {
                    perspective: 1000px;
                }
                .preserve-3d {
                    transform-style: preserve-3d;
                    transition: transform 0.5s cubic-bezier(0.23, 1, 0.32, 1), box-shadow 0.5s ease;
                }
                .preserve-3d:hover {
                    transform: translateY(-8px) rotateX(3deg) rotateY(-2deg);
                }
                .gradient-text-animated {
                    background: linear-gradient(135deg, #059669 0%, #10B981 50%, #D97706 100%);
                    background-size: 200% auto;
                    color: transparent;
                    -webkit-background-clip: text;
                    animation: shine 4s linear infinite;
                }
                @keyframes shine {
                    to { background-position: 200% center; }
                }
            `}</style>

           
 
           {/* NEW TOP HEADING SECTION */}
            <section className="py-12 bg-white border-b border-slate-200 text-center">
                <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
                    <h2 className="text-3xl sm:text-4xl font-extrabold text-slate-900 tracking-tight">
                        NextEra Research API Bridge Service
                    </h2>
                    <p className="text-slate-600 mt-3 text-base sm:text-lg font-medium">
                        Seamless integration for your trading and research needs
                    </p>
                </div>
            </section>
            {/* 3. SECTION 1: ABOUT API BRIDGE + ENHANCED 3D RADIAL DIAGRAM */}
            <section id="services" className="py-16 lg:py-20 bg-gradient-to-b from-emerald-50/50 via-white to-slate-50 relative overflow-hidden">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
                    <div className="grid lg:grid-cols-12 gap-12 items-center">
                        <div className="lg:col-span-6 space-y-6">
                            <span className="inline-flex items-center gap-2 px-3.5 py-1.5 bg-emerald-100 text-emerald-800 rounded-full text-xs font-bold uppercase tracking-wider border border-emerald-200">
                                Automated Integration
                            </span>
                            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-slate-900 leading-tight">
                                About Our <span className="gradient-text-animated">API Bridge Service</span>
                            </h1>
                            <p className="text-slate-600 leading-relaxed text-sm sm:text-base font-normal">
In today's fast-paced financial markets, seamless communication between trading platforms and research tools is essential. Our API Bridge service provides this critical connection, enabling real-time data exchange between your systems and our research analytics.                            </p>
                            <p className="text-slate-600 leading-relaxed text-sm sm:text-base font-normal">
As a dedicated research analytics, we offer this integration capability across all our services - Options, Cash, Futures, and MCX. The API Bridge gives you flexible configuration options with both manual and automatic modes to suit your trading style.                            </p>
                            <p className="text-slate-600 leading-relaxed text-sm sm:text-base font-normal">
Customize your integration with position sizing based on your investment profile and other parameters. Please note this is a delivery mechanism only - all trading calls originate from our research analysts based on market conditions.                            </p>
                        </div>

                        {/* Interactive 3D Radial Diagram */}
                        <div className="lg:col-span-6 perspective-1000">
                            <div className="preserve-3d bg-white/90 border border-slate-200/90 backdrop-blur-xl p-8 rounded-3xl shadow-2xl relative flex flex-col items-center justify-center min-h-[460px]">
                                <div className="absolute top-0 left-0 right-0 h-1.5 bg-gradient-to-r from-emerald-500 via-teal-500 to-amber-500 rounded-t-3xl"></div>
                                <div className="text-xs font-extrabold uppercase tracking-widest text-emerald-700 bg-emerald-100 border border-emerald-200 px-3 py-1 rounded-full mb-8">
                                    Seamless Integration Architecture
                                </div>
                                <div className="relative w-72 h-72 sm:w-80 sm:h-80 flex items-center justify-center">
                                    <div className="z-20 w-28 h-28 sm:w-32 sm:h-32 bg-gradient-to-br from-purple-700 to-indigo-900 text-white rounded-full flex items-center justify-center text-center p-3 shadow-xl shadow-purple-900/30 font-extrabold text-sm sm:text-base border-4 border-white">
                                        API TRADING
                                    </div>
                                    <div className="absolute -top-4 w-24 h-24 bg-cyan-500 text-white rounded-full flex items-center justify-center text-center p-2 text-xs font-bold shadow-lg border-2 border-white hover:scale-110 transition-transform">
                                        Initiation price
                                    </div>
                                    <div className="absolute top-8 -right-4 w-24 h-24 bg-teal-500 text-white rounded-full flex items-center justify-center text-center p-2 text-xs font-bold shadow-lg border-2 border-white hover:scale-110 transition-transform">
                                        Quantity
                                    </div>
                                    <div className="absolute bottom-8 -right-4 w-24 h-24 bg-green-500 text-white rounded-full flex items-center justify-center text-center p-2 text-xs font-bold shadow-lg border-2 border-white hover:scale-110 transition-transform">
                                        Order type
                                    </div>
                                    <div className="absolute -bottom-4 w-24 h-24 bg-lime-500 text-white rounded-full flex items-center justify-center text-center p-2 text-xs font-bold shadow-lg border-2 border-white hover:scale-110 transition-transform">
                                        Profit targets
                                    </div>
                                    <div className="absolute bottom-8 -left-4 w-24 h-24 bg-yellow-400 text-slate-900 rounded-full flex items-center justify-center text-center p-2 text-xs font-bold shadow-lg border-2 border-white hover:scale-110 transition-transform">
                                        Trailing stops
                                    </div>
                                    <div className="absolute top-8 -left-4 w-24 h-24 bg-amber-500 text-white rounded-full flex items-center justify-center text-center p-2 text-xs font-bold shadow-lg border-2 border-white hover:scale-110 transition-transform">
                                        Exit price
                                    </div>
                                </div>
                                <p className="text-[11px] text-slate-500 mt-8 font-medium">Connect your trading platform with our research signals in minutes</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* 4. SECTION 2: Manual vs Algo Comparison Matrix */}
            <section className="py-20 bg-white border-y border-slate-200">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="text-center max-w-3xl mx-auto mb-12">
                        <span className="text-xs font-bold uppercase tracking-widest text-emerald-600">Manual vs Algo Trading</span>
                        <h2 className="text-3xl sm:text-4xl font-extrabold text-slate-900 mt-2">Side-by-Side Comparison</h2>
                        <p className="text-slate-600 mt-3 text-sm sm:text-base">Understand the clear difference between human-driven trading and rule-based algorithmic trading through real-world comparisons.</p>
                    </div>

                    <div className="bg-slate-50 border border-slate-200 rounded-3xl shadow-xl overflow-hidden">
                        <div className="overflow-x-auto">
                            <table className="w-full text-left text-sm">
                                <thead className="bg-slate-900 text-white text-xs uppercase tracking-wider">
                                    <tr>
                                        <th className="py-4 px-6 font-bold">Aspect</th>
                                        <th className="py-4 px-6 font-bold text-rose-400 bg-slate-950/50">Manual Trading</th>
                                        <th className="py-4 px-6 font-bold text-emerald-400 bg-slate-950">Algo Trading (NexEra Research Approach)</th>
                                    </tr>
                                </thead>
                                <tbody className="divide-y divide-slate-200 font-medium text-slate-700">
                                    <tr className="hover:bg-slate-100/80 transition">
                                        <td className="py-4 px-6 font-bold text-slate-900">Execution</td>
                                        <td className="py-4 px-6 text-rose-700 bg-rose-50/30">इंसान खुद market देख के trade करता है</td>
                                        <td className="py-4 px-6 text-emerald-800 bg-emerald-50/30 font-bold">Software rules के हिसाब से auto execute होता है</td>
                                    </tr>
                                    <tr className="hover:bg-slate-100/80 transition">
                                        <td className="py-4 px-6 font-bold text-slate-900">Speed</td>
                                        <td className="py-4 px-6 text-rose-700 bg-rose-50/30">Slow – Human delay</td>
                                        <td className="py-4 px-6 text-emerald-800 bg-emerald-50/30 font-bold">Fast – Milliseconds में order</td>
                                    </tr>
                                    <tr className="hover:bg-slate-100/80 transition">
                                        <td className="py-4 px-6 font-bold text-slate-900">Emotion</td>
                                        <td className="py-4 px-6 text-rose-700 bg-rose-50/30">Fear, Greed affect decisions</td>
                                        <td className="py-4 px-6 text-emerald-800 bg-emerald-50/30 font-bold">Zero emotion – Rules आधारित</td>
                                    </tr>
                                    <tr className="hover:bg-slate-100/80 transition">
                                        <td className="py-4 px-6 font-bold text-slate-900">Discipline</td>
                                        <td className="py-4 px-6 text-rose-700 bg-rose-50/30">Hard to maintain</td>
                                        <td className="py-4 px-6 text-emerald-800 bg-emerald-50/30 font-bold">Fully disciplined execution ✓</td>
                                    </tr>
                                    <tr className="hover:bg-slate-100/80 transition">
                                        <td className="py-4 px-6 font-bold text-slate-900">Consistency</td>
                                        <td className="py-4 px-6 text-rose-700 bg-rose-50/30">Inconsistent</td>
                                        <td className="py-4 px-6 text-emerald-800 bg-emerald-50/30 font-bold">Consistent results across trades</td>
                                    </tr>
                                    <tr className="hover:bg-slate-100/80 transition">
                                        <td className="py-4 px-6 font-bold text-slate-900">Risk Control</td>
                                        <td className="py-4 px-6 text-rose-700 bg-rose-50/30">Varies human to human</td>
                                        <td className="py-4 px-6 text-emerald-800 bg-emerald-50/30 font-bold">Pre-defined risk parameters</td>
                                    </tr>
                                    <tr className="hover:bg-slate-100/80 transition">
                                        <td className="py-4 px-6 font-bold text-slate-900">Backtesting</td>
                                        <td className="py-4 px-6 text-rose-700 bg-rose-50/30">Not feasible</td>
                                        <td className="py-4 px-6 text-emerald-800 bg-emerald-50/30 font-bold">Extensive historical testing</td>
                                    </tr>
                                    <tr className="hover:bg-slate-100/80 transition">
                                        <td className="py-4 px-6 font-bold text-slate-900">24/7 Monitoring</td>
                                        <td className="py-4 px-6 text-rose-700 bg-rose-50/30">Impossible</td>
                                        <td className="py-4 px-6 text-emerald-800 bg-emerald-50/30 font-bold">Possible with automation</td>
                                    </tr>
                                    <tr className="hover:bg-slate-100/80 transition">
                                        <td className="py-4 px-6 font-bold text-slate-900">Scalability</td>
                                        <td className="py-4 px-6 text-rose-700 bg-rose-50/30">Limited</td>
                                        <td className="py-4 px-6 text-emerald-800 bg-emerald-50/30 font-bold">Highly scalable</td>
                                    </tr>
                                    <tr className="hover:bg-slate-100/80 transition">
                                        <td className="py-4 px-6 font-bold text-slate-900">Execution Cost</td>
                                        <td className="py-4 px-6 text-rose-700 bg-rose-50/30">Higher due to mistakes, slippage</td>
                                        <td className="py-4 px-6 text-emerald-800 bg-emerald-50/30 font-bold">Lower with precise entry/exit</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </section>

            {/* 5. SECTION 3: Pain Points vs Gain Points 3D Cards */}
            <section className="py-20 bg-slate-100">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="text-center max-w-3xl mx-auto mb-16">
                        <span className="text-xs font-bold uppercase tracking-widest text-emerald-600">Decision Analysis</span>
                        <h2 className="text-3xl sm:text-4xl font-extrabold text-slate-900 mt-2">Manual Trading vs Algo Trading</h2>
                    </div>

                    <div className="grid md:grid-cols-2 gap-8">
                        <div className="perspective-1000">
                            <div className="preserve-3d bg-white border border-rose-200 p-8 rounded-3xl shadow-xl relative group h-full">
                                <div className="inline-flex items-center gap-2 px-3.5 py-1 bg-rose-100 text-rose-700 text-xs font-extrabold uppercase rounded-full mb-6">
                                    ❌ Manual Trading Pain Points
                                </div>
                                <ul className="space-y-4 text-sm font-semibold text-slate-700">
                                    <li className="flex items-center gap-3"><span className="w-6 h-6 rounded-full bg-rose-100 text-rose-600 flex items-center justify-center font-extrabold text-xs">✕</span> Emotion control नहीं</li>
                                    <li className="flex items-center gap-3"><span className="w-6 h-6 rounded-full bg-rose-100 text-rose-600 flex items-center justify-center font-extrabold text-xs">✕</span> Late entry – Early exit</li>
                                    <li className="flex items-center gap-3"><span className="w-6 h-6 rounded-full bg-rose-100 text-rose-600 flex items-center justify-center font-extrabold text-xs">✕</span> Fear & Greed driven decisions</li>
                                    <li className="flex items-center gap-3"><span className="w-6 h-6 rounded-full bg-rose-100 text-rose-600 flex items-center justify-center font-extrabold text-xs">✕</span> Discipline follow नहीं होता</li>
                                    <li className="flex items-center gap-3"><span className="w-6 h-6 rounded-full bg-rose-100 text-rose-600 flex items-center justify-center font-extrabold text-xs">✕</span> Screen पर पूरा दिन</li>
                                    <li className="flex items-center gap-3"><span className="w-6 h-6 rounded-full bg-rose-100 text-rose-600 flex items-center justify-center font-extrabold text-xs">✕</span> No proper back-testing</li>
                                    <li className="flex items-center gap-3"><span className="w-6 h-6 rounded-full bg-rose-100 text-rose-600 flex items-center justify-center font-extrabold text-xs">✕</span> Weak risk management</li>
                                    <li className="flex items-center gap-3"><span className="w-6 h-6 rounded-full bg-rose-100 text-rose-600 flex items-center justify-center font-extrabold text-xs">✕</span> Limited growth & scalability</li>
                                </ul>
                            </div>
                        </div>

                        <div className="perspective-1000">
                            <div className="preserve-3d bg-emerald-900 text-white p-8 rounded-3xl shadow-2xl relative group h-full border border-emerald-700">
                                <div className="inline-flex items-center gap-2 px-3.5 py-1 bg-emerald-500/20 text-emerald-300 border border-emerald-500/30 text-xs font-extrabold uppercase rounded-full mb-6">
                                    ✓ Algo Trading Gain Points
                                </div>
                                <ul className="space-y-4 text-sm font-semibold text-emerald-100">
                                    <li className="flex items-center gap-3"><span className="w-6 h-6 rounded-full bg-emerald-500 text-slate-950 flex items-center justify-center font-extrabold text-xs">✓</span> Emotion-free execution</li>
                                    <li className="flex items-center gap-3"><span className="w-6 h-6 rounded-full bg-emerald-500 text-slate-950 flex items-center justify-center font-extrabold text-xs">✓</span> Perfect entry & exit</li>
                                    <li className="flex items-center gap-3"><span className="w-6 h-6 rounded-full bg-emerald-500 text-slate-950 flex items-center justify-center font-extrabold text-xs">✓</span> 100% rule-based discipline</li>
                                    <li className="flex items-center gap-3"><span className="w-6 h-6 rounded-full bg-emerald-500 text-slate-950 flex items-center justify-center font-extrabold text-xs">✓</span> Back-tested & data-driven</li>
                                    <li className="flex items-center gap-3"><span className="w-6 h-6 rounded-full bg-emerald-500 text-slate-950 flex items-center justify-center font-extrabold text-xs">✓</span> Strong risk management</li>
                                    <li className="flex items-center gap-3"><span className="w-6 h-6 rounded-full bg-emerald-500 text-slate-950 flex items-center justify-center font-extrabold text-xs">✓</span> Screen-free trading</li>
                                    <li className="flex items-center gap-3"><span className="w-6 h-6 rounded-full bg-emerald-500 text-slate-950 flex items-center justify-center font-extrabold text-xs">✓</span> Multiple stocks, one system</li>
                                    <li className="flex items-center gap-3"><span className="w-6 h-6 rounded-full bg-emerald-500 text-slate-950 flex items-center justify-center font-extrabold text-xs">✓</span> Scalable & consistent growth</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* 6. SECTION 4: ADVANCED RESEARCH SOLUTIONS */}
            <section className="py-20 bg-white border-y border-slate-200">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="bg-slate-50 rounded-3xl p-8 sm:p-12 border border-slate-200 shadow-xl grid lg:grid-cols-12 gap-8 items-center">
                        <div className="lg:col-span-6 space-y-4">
                            <span className="text-xs font-bold uppercase tracking-widest text-slate-900">Advanced Research Solutions</span>
                            <h2 className="text-2xl sm:text-3xl font-extrabold text-slate-900">Powerful API Bridge Technology for Modern Trading</h2>
                            <p className="text-slate-600 text-sm leading-relaxed">
                                An API bridge in trading is a software interface that connects different systems involved in the trading process, such as trading platforms, algorithmic trading software, and brokers. It facilitates automated trading, real-time data analysis, and efficient execution of trading signals.
                            </p>
                            <p className="text-slate-600 text-sm leading-relaxed">
                                API bridges allow for seamless integration and communication between these systems, enabling traders to automate their strategies and execute trades with speed and accuracy.
                            </p>
                        </div>
                        <div className="lg:col-span-6 bg-white p-6 sm:p-8 rounded-2xl border border-slate-200 shadow-sm space-y-4">
                            <h3 className="text-sm font-bold uppercase tracking-wider text-slate-900 mb-2">Key Features:</h3>
                            <div className="flex items-start gap-3">
                                <span className="w-5 h-5 rounded-full bg-emerald-100 text-emerald-600 flex items-center justify-center font-bold text-xs mt-0.5 shrink-0">✓</span>
                                <p className="text-sm text-slate-700"><strong className="text-slate-900">Connecting Systems:</strong> Acts as a bridge between trading platforms, algorithmic trading software, and brokers</p>
                            </div>
                            <div className="flex items-start gap-3">
                                <span className="w-5 h-5 rounded-full bg-emerald-100 text-emerald-600 flex items-center justify-center font-bold text-xs mt-0.5 shrink-0">✓</span>
                                <p className="text-sm text-slate-700"><strong className="text-slate-900">Automated Trading:</strong> Enables execution of research signals without manual intervention</p>
                            </div>
                            <div className="flex items-start gap-3">
                                <span className="w-5 h-5 rounded-full bg-emerald-100 text-emerald-600 flex items-center justify-center font-bold text-xs mt-0.5 shrink-0">✓</span>
                                <p className="text-sm text-slate-700"><strong className="text-slate-900">Real-time Data Analysis:</strong> Provides access to live market data for informed decision making</p>
                            </div>
                            <div className="flex items-start gap-3">
                                <span className="w-5 h-5 rounded-full bg-emerald-100 text-emerald-600 flex items-center justify-center font-bold text-xs mt-0.5 shrink-0">✓</span>
                                <p className="text-sm text-slate-700"><strong className="text-slate-900">Efficient Execution:</strong> Reduces latency and improves order placement speed</p>
                            </div>
                            <div className="flex items-start gap-3">
                                <span className="w-5 h-5 rounded-full bg-emerald-100 text-emerald-600 flex items-center justify-center font-bold text-xs mt-0.5 shrink-0">✓</span>
                                <p className="text-sm text-slate-700"><strong className="text-slate-900">Integration:</strong> Ensures accurate and efficient data/order transmission between systems</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            

            {/* 7. SECTION 5: CHOOSE YOUR API PLAN (Dynamic Data Driven) */}
          {/* CHOOSE YOUR API PLAN SECTION */}
            <section id="pricing" className="py-24 bg-slate-50">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="text-center max-w-3xl mx-auto mb-16">
                        <h2 className="text-3xl sm:text-4xl font-extrabold text-slate-900 mt-2">Choose Your API Plan</h2>
                    </div>

                    <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-4">
                        {plans.map((plan, index) => {
                            const isPopular = plan.popular || plan.premium;
                            return (
                                <div key={index} className="perspective-1000">
                                    <div className={`preserve-3d p-8 rounded-3xl shadow-xl flex flex-col justify-between h-full relative group border transition-all duration-300 hover:shadow-2xl ${
                                        isPopular 
                                            ? "bg-emerald-900 text-white border-2 border-emerald-500 transform lg:-translate-y-4" 
                                            : "bg-white text-slate-800 border-slate-200"
                                    }`}>
                                        {isPopular && (
                                            <div className="absolute -top-3 right-6 bg-amber-400 text-slate-950 text-[10px] font-extrabold uppercase px-3 py-1 rounded-full shadow">
                                                {plan.popularLabel || "Popular"}
                                            </div>
                                        )}
                                        <div>
                                            <h3 className={`text-lg font-bold mb-2 ${isPopular ? "text-emerald-300" : "text-slate-900"}`}>
                                                {plan.title}
                                            </h3>
                                            <div className={`text-3xl font-extrabold mb-6 ${isPopular ? "text-white" : "text-slate-900"}`}>
                                                {plan.price}
                                            </div>
                                            <ul className={`space-y-3 text-xs ${isPopular ? "text-emerald-100" : "text-slate-600"}`}>
                                                {plan.features.map((feature, i) => (
                                                    <li key={i} className="flex items-center gap-2">
                                                        <span className={isPopular ? "text-emerald-300 font-bold" : "text-emerald-500 font-bold"}>✓</span>
                                                        <span>{feature}</span>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                        <div className="mt-8 text-center">
                                            <button
                                                onClick={() => {
                                                    const numericPrice = Number(plan.price.replace(/[₹,\s]/g, ""));
                                                    navigate("/secure-payment", {
                                                        state: {
                                                            price: numericPrice,
                                                            planTitle: plan.title,
                                                        },
                                                    });
                                                }}
                                                className={`w-full rounded-xl font-bold py-3 px-6 transition duration-300 shadow-md ${
                                                    isPopular 
                                                        ? "bg-emerald-500 hover:bg-emerald-400 text-slate-950 shadow-lg" 
                                                        : "bg-emerald-600 hover:bg-emerald-700 text-white shadow-emerald-600/20"
                                                }`}
                                            >
                                                {plan.buttonText || "Buy Now"}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </section>

            {/* CTA Section */}
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-20">
                <div className="bg-emerald-50 rounded-3xl p-8 sm:p-12 text-center border border-emerald-100 shadow-sm">
                    <h3 className="text-2xl font-bold text-slate-900 mb-4">Need a custom solution?</h3>
                    <p className="text-slate-600 mb-8 max-w-2xl mx-auto text-sm sm:text-base">
                        Our team can create a tailored API integration to meet your specific requirements and trading volume.
                    </p>
                    <button 
                        onClick={() => navigate('/contactus')} 
                        className="bg-emerald-600 hover:bg-emerald-700 text-white font-bold py-3.5 px-8 rounded-xl transition duration-300 inline-flex items-center gap-3 shadow-lg shadow-emerald-600/20 hover:scale-105"
                    >
                        Contact Us <FaArrowRight />
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ApiServices;